import Barchart from "./Barchart"
import React, { useState, useEffect } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';


function AnnualTrafficChange({setloading5}){


  //States for setting Chart Data and Options
  const [yearlyMovementChangeData, setyearlyMovementChangeData] = useState({datasets: [],});
  const [yearlyMovementChangeOptions, setyearlyMovementChangeOptions] = useState({});

  //State for handling Data for downloading into Excel file
  const [excelDataChart1,setexcelDataChart1] = useState([]);

  useEffect(() => {

    fetch("api/cargo_post_change").then((res) =>
      res.json().then((res) => {
        
        setexcelDataChart1(res.data["ετήσιες μεταβολές"]);


        let listOfIds = []
        let data1 = []
        let data2 = []
        let data3 = []
        let data4 = []

        res.data["ετήσιες μεταβολές"].forEach((years, i) => {
          listOfIds.push(years["Έτος 1"] + "-" + years["Έτος 2"]);
          data1.push(years["Εμπορεύματα προέλευσης"])
          data2.push(years["Εμπορεύματα προορισμού"])
          data3.push(years["Ταχυδρομείο προέλευσης"])
          data4.push(years["Ταχυδρομείο προορισμού"])
        });

          setyearlyMovementChangeData({
              labels : listOfIds,
              datasets: [
                  {
                  label: 'Εμπορεύματα προέλευσης',
                  axis : "y",
                  data: data1,
                  backgroundColor: '#75D1D8',
                  barPercentage: 0.8,
                  categoryPercentage: 0.5,
          
                  },
                  {
                  label: 'Εμπορεύματα προορισμού',
                  data: data2,
                  backgroundColor: "#A471D1",
                  barPercentage: 0.8,
                  categoryPercentage: 0.5,
                  },
                  {
                  label: 'Ταχυδρομείο προέλευσης',
                  axis : "y",
                  data: data3,
                  backgroundColor: '#0F8DD6',
                  barPercentage: 0.8,
                  categoryPercentage: 0.5,
          
                  },
                  {
                  label: 'Ταχυδρομείο προορισμού',
                  axis : "y",
                  data: data4,
                  backgroundColor: '#012D81',
                  barPercentage: 0.8,
                  categoryPercentage: 0.5,
          
                  }
              ]
          })

          setyearlyMovementChangeOptions({
              maintainAspectRatio: false,
              responsive: true,
              indexAxis: 'y',
              plugins: {
              legend: {
                  position: 'bottom',
              },
              },
              scales: {
              y: {
                  suggestedMin: 0,
                  max: 7
              }
              }
          })
          setloading5(false)
          
  
          })
    )
    .catch((error) => {
      console.log("Refetching data for Plot1!")
    })

  }, [setloading5]);
  


  return(
      excelDataChart1.length  !== 0 ? <Barchart chartData={yearlyMovementChangeData} chartOptions = {yearlyMovementChangeOptions} excelData ={excelDataChart1}/>:
        <div className="loading-spinner" style = {{margin: "auto"}}>
        <ClipLoader size={100} color={'#123abc'} loading={true} />
        
    </div>
       
  )
}




export default AnnualTrafficChange;